export default __webpack_public_path__ + "static/media/basic.86d5e514.png";